import posthog from 'posthog-js';

// Thin wrapper — callers import from here so PostHog can be swapped without touching every file.

export function identify(userId, traits = {}) {
  try { posthog.identify(userId, traits); } catch {}
}

export function track(event, properties = {}) {
  try { posthog.capture(event, properties); } catch {}
}

export function reset() {
  try { posthog.reset(); } catch {}
}
